export const RoomTypeFeatures = [
  'Bathtub',
  'Mini Bar',
  'Accessibility',
  'HD TV',
  'Fridge',
  'Safe',
  'Hairdryer',
  'Clothing Iron',
  'Laundry Services',
  'Toiletries',
  'Tablet',
  'Voice Control',
  'Daily Newspaper',
  'Bathrobes',
  'Kettle',
  'Free WiFi',
  'Seaside View',
  'Pool View',
  'Kid-friendly Room',
  'Study',
  'High Speed Internet',
  'Daily Room Service',
  'Spa',
  'BBQ Area',
  'Pet Friendly',
];

export const SuggestedRoomTypeFeatures = [
  'Bathtub',
  'Hairdryer',
  'Toiletries',
  'Tablet',
  'BBQ Area',
  'Pet Friendly',
];

export const SuggestedHotelFeatures = [
  'Internet',
  'Parking',
  'F&B',
  'Wellness',
  'Spa',
  'Gym',
  'Swimming Pool',
  'Golf',
  'Accessibility',
  'Event Spaces',
  'Bathtub',
  'Coffee Machine',
  'International Buffet',
];
